import { AdUnit } from './Analytics';
import { AD_SLOTS } from '@/config/analytics';

// 横幅广告组件
export function BannerAd({ className }: { className?: string }) {
  return (
    <div className={`w-full flex justify-center my-4 ${className || ''}`}>
      <AdUnit
        adSlot={AD_SLOTS.banner.slot}
        adFormat={AD_SLOTS.banner.format}
        style={AD_SLOTS.banner.style}
        className="w-full max-w-4xl"
      />
    </div>
  );
}

// 侧边栏广告组件
export function SidebarAd({ className }: { className?: string }) {
  return (
    <div className={`sticky top-4 ${className || ''}`}>
      <div className="text-xs text-muted-foreground mb-2 text-center">广告</div>
      <AdUnit
        adSlot={AD_SLOTS.sidebar.slot}
        adFormat={AD_SLOTS.sidebar.format}
        style={AD_SLOTS.sidebar.style}
      />
    </div>
  );
}

// 文章内广告组件
export function InArticleAd({ className }: { className?: string }) {
  return (
    <div className={`my-8 flex justify-center ${className || ''}`}>
      <div className="w-full max-w-md">
        <div className="text-xs text-muted-foreground mb-2 text-center">广告</div>
        <AdUnit
          adSlot={AD_SLOTS.inArticle.slot}
          adFormat={AD_SLOTS.inArticle.format}
          style={AD_SLOTS.inArticle.style}
        />
      </div>
    </div>
  );
}

// 页脚广告组件
export function FooterAd({ className }: { className?: string }) {
  return (
    <div className={`w-full border-t border-border/50 pt-4 ${className || ''}`}>
      <div className="text-xs text-muted-foreground mb-2 text-center">广告</div>
      <AdUnit
        adSlot={AD_SLOTS.footer.slot}
        adFormat={AD_SLOTS.footer.format}
        style={AD_SLOTS.footer.style}
        className="w-full"
      />
    </div>
  );
}

// 响应式广告组件
export function ResponsiveAd({ 
  adSlot, 
  className,
  label = '广告'
}: { 
  adSlot: string;
  className?: string;
  label?: string;
}) {
  return (
    <div className={`my-4 ${className || ''}`}>
      <div className="text-xs text-muted-foreground mb-2 text-center">{label}</div>
      <AdUnit
        adSlot={adSlot}
        adFormat="auto"
        style={{ minHeight: '100px' }}
        className="w-full"
      />
    </div>
  );
}